import {ProjectView_AccessControl} from "../../access/acl"
import ProjectView from "../../project-view"
import {RequestFormType} from "../../../../../app/tools/request-forms2/const/const";

export class ProjectView_Form_AccessControl extends ProjectView_AccessControl {

    constructor(projectView:ProjectView) {
        super(projectView)
    }

    get canRename():boolean {
        return false
    }

    get canCopyURL(): boolean {
        const form = _.find(this.projectView.projectViews.project.properties.forms, form => form.id === this.projectView.config.formId)
        return form?.type === RequestFormType.FORM
    }

    get canEditForm():boolean {
        return this.isPrivateViewOwner || this.hasFullAccess
    }

    get canCreateNew():boolean {
        return false
    }

    get canDuplicate():boolean {
        return false
    }

    get canResetToDefault():boolean {
        return false
    }

    get canDelete():boolean {
        return this.isPrivateViewOwner || this.hasFullAccess
    }

    get canUseTemplates():boolean {
        return false
    }

    get canSaveAsTemplate():boolean {
        return false
    }

    get canLoadTemplate():boolean {
        return false
    }

    get canEditPermissions():boolean {
        return false // this.isPrivateViewOwner || this.hasFullAccess
    }

    get canSetPublicPermission():boolean {
        return false // this.hasFullAccess
    }

    get canSetAsToDefault():boolean {
        return false
    }
}

